import React, { useEffect, useState } from "react"
import LoadingScreen from "react-loading-screen";
import logo from "../../assets/img/logo/logo_aig_login-2.png";
import Page from "../../components/Page";
import { urlListarComprasCliente } from "../../constants/urls";
import { connect } from "react-redux"
import { withRouter } from "react-router-dom";
import { Alert, Button, Card, CardBody, CardHeader, } from "reactstrap";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { useSolicitarSuscripcionRenovacion } from "./ComprasHooks";

const MisComprasContainer = (props) => {
  const [isLoading, setLoading] = useState(false);
  const [compras, setCompras] = useState([]);
  const { cedula } = props.dataUsuario
  const solicitarSuscripcion = useSolicitarSuscripcionRenovacion();
  const [visible, setVisible] = useState(false);

  const onDismiss = () => setVisible(false);

  /**
   * Obtener la lista de compras del cliente
   */
  const getData = async () => {
    setLoading(true)

    try {
      const res = await fetch(urlListarComprasCliente(cedula))
      const json = await res.json()
      if (json.transaccion) {
        setCompras(json.data)
      }
      console.log(json)
    } catch (e) {
      console.log(e)
    }
    setLoading(false)
  }

  useEffect(() => {
    getData()
  }, []);


  /**
   * 
   * @param {Object} rowData Objeto con información de la poliza
   * @returns {} Retorna los botones de acción
   */
  const bodyBtn = (rowData) => {

    /**
     *  Ir a la pantralla de recompra
     */
    const onClickRecompra = async () => {
      console.clear();
      props.history.push({
        pathname: "/recompra",
        search: `?id=${rowData.polId}`,
      });
    }


    /**
     * Solicitar suscripción
     */
    const onClick = async () => {
      setLoading(true)
      const res = await solicitarSuscripcion(rowData.polId)
      if (res.transaccion && res.traUrl) {
        window.location.href = res.traUrl
      } else {
        setVisible(true)
        setLoading(false)
      }

    }

    return <div>
      {(
        rowData.polDescripcion == 'AUTOXKMDINERS' ||
        rowData.polDescripcion == 'CUPO SEGURO'
      ) &&
        <Button className="btn btn-block btn-primary" onClick={onClick}>
          Cambiar forma de pago
        </Button>
      }
      {rowData.polDescripcion == 'KilometroPaquete' && rowData.numeroPolizaEmision!="" && rowData.tieneRecompra == false && <Button className="btn btn-block btn-primary" onClick={onClickRecompra}>
        Recompra
      </Button>}
    </div>
  }

  /**
   * 
   * @param {string} str valor para la validación 
   * @returns {string} valor aumentado el cero adelante
   * Función para añadir el cero delante de un número 
   */
  const validarCero = (str) => {
    if (String(str).length === 1) {
      return `0${str}`
    }
    return str
  }


  return (<main className="bg-light">
    <div className="cr-content container-fluid">
      <div className="container-body-spaces">
        <LoadingScreen
          loading={isLoading}
          bgColor="#f1f1f1"
          spinnerColor="#001871"
          textColor="#676767"
          logoSrc={logo}
          text={"Cargando..."}
        >
          <Page title="Listado de Compras"
            breadcrumbs={[{ name: "Listado de Compras", active: true }]}>


            <div className="row">

              <div className="col-md-12">
                <Alert
                  className="text-uppercase" color="warning" isOpen={visible}
                  toggle={onDismiss}
                >
                  HA OCURRIDO UN PROBLEMA AL HACER LA PETICIóN DE SUSCRIPCóN
                </Alert>
              </div>

              <div className="col-12 detalle-cotizacion-box">

                <Card className="mb-3">
                  <CardHeader style={{ borderBottom: "none" }} />
                  <CardBody>
                    {
                      //pagos.length > 0 &&
                      <DataTable
                        value={compras}
                        responsive
                        className="p-datatable-customers"
                        rowHover
                        paginator
                        rows={10}
                        rowsPerPageOptions={[10, 25, 50]}
                        emptyMessage="No se han encontrado resultados"
                        resizableColumns
                      >
                        <Column
                          className="counter"
                          header="#"
                          body={(rowData, { rowIndex }) => {
                            return rowIndex + 1
                          }}
                          style={{ width: "60px" }}
                        />
                        <Column
                          header="Fecha"
                          sortable
                          body={(rowData) => {
                            const date = new Date(Number(rowData.polFecha.$date.$numberLong));
                            return `${date.getFullYear()}-${validarCero(date.getMonth() + 1)}-${validarCero(date.getDate())}`;

                          }}
                          style={{ width: "100px" }}
                        />
                        <Column
                          field="polNumero"
                          header="Número de Póliza"
                          sortable
                          style={{ width: "100px" }}
                        />
                        <Column
                          field="polDescripcion"
                          header="Producto"
                          sortable
                          style={{ width: "100px" }}
                        />
                        <Column
                          field="polRamo"
                          header="RAMO"
                          sortable
                          style={{ width: "100px" }}
                        />
                        <Column
                          field="tarNumero"
                          header="Tarjeta Suscrita"
                          sortable
                          style={{ width: "100px" }}
                        />
                        <Column
                          field="tarTipo"
                          header="Tipo de Tarjeta"
                          sortable
                          style={{ width: "100px" }}
                        />
                        <Column
                          body={bodyBtn}
                          style={{ width: "150px" }}
                        />
                      </DataTable>
                    }
                  </CardBody>

                </Card>


              </div>
            </div>


            {compras.length === 0 && (
              <div className="row">
                <div className="col-12 detalle-cotizacion-box">
                  <Card className="mb-3">
                    <CardHeader style={{ borderBottom: "none" }} />
                    <CardBody>
                      <h2 style={{ color: "#001871", textAlign: "center" }}>
                        NO SE HA ENCONTRADO REGISTROS DE COMPRAS REALIZADOS
                      </h2>
                    </CardBody>
                  </Card>
                </div>
              </div>
            )}

          </Page>
        </LoadingScreen>
      </div>
    </div>
  </main>)

}

const mapStateToProps = (state) => ({
  dataUsuario: state.datosUsuarios.dataUsuario
});

export default withRouter(
  connect(mapStateToProps, null)(MisComprasContainer)
)